export default "__VITE_ASSET__6dc69e96__"